<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            New Cluster
          </h4>
          <h6 class="card-subtitle">
            Add a new cluster to be audited.
          </h6>
        </div>
        <form class="form-horizontal" @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-md-6">
              <div class="card-body card-blue">
                <h6 class="card-title">
                  Cluster Info
                </h6>

                <div class="form-group row">
                  <label class="col-sm-3 text-right control-label col-form-label" for="name">Cluster Name</label>
                  <div class="col-sm-7">
                    <input id="name" v-model="cluster.name" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('name')}" class="form-control" data-vv-as="Name" name="name" placeholder="Name" type="text">
                    <small class="form-text text-muted">This is how others will identify your Cluster</small>
                    <div v-if="submitted && errors.has('name')" class="invalid-feedback">
                      {{ errors.first('name') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 text-right control-label col-form-label" for="description">Description</label>
                  <div class="col-sm-7">
                    <textarea id="description" v-model="cluster.description" :class="{'is-invalid': submitted && errors.has('description')}" class="form-control" data-vv-as="Description" name="description" placeholder="Description" rows="4" type="text" />
                    <div v-if="submitted && errors.has('description')" class="invalid-feedback">
                      {{ errors.first('description') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 text-right control-label col-form-label" for="geo">Coordinate</label>
                  <div class="col-sm-7">
                    <input id="geo" v-model="cluster.geo.geometry.coordinates" v-validate="'required'" class="form-control" disabled name="geo" placeholder="Coordinate" type="text">
                    <small class="form-text text-muted">Cluster's geographical coordinate</small>
                    <!--<div v-if="submitted && errors.has('name')" class="invalid-feedback">{{ errors.first('name') }}</div>-->
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-3 text-right control-label col-form-label" for="coops">Select Coop</label>
                  <div class="col-sm-7">
                    <multiselect id="coops" v-model="coop" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('coops')}" :multiple="false" :options="coops" class="form-control" label="name" name="coops" placeholder="Select a Coop" track-by="id" @select="getFarms" @remove="resetFarm">
                      <template slot="tag" slot-scope="{ option, remove }">
                        <span class="recipient-tag">
                          <span>{{ ` ${option.name} ` }}</span>
                          <span class="recipient-remove" @click="remove(option)">❌</span>
                        </span>
                      </template>
                    </multiselect>
                    <div v-if="submitted && errors.has('coops')" class="invalid-feedback">
                      {{ errors.first('coops') }}
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-3 text-right control-label col-form-label" for="farms">Select Farms</label>
                  <div class="col-sm-7">
                    <multiselect id="farms" v-model="farms" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('farms')}" :multiple="true" :options="farmList" class="form-control" label="name" name="farms" placeholder="Select a Farm" track-by="id">
                      <template slot="tag" slot-scope="{ option, remove }">
                        <span class="recipient-tag">
                          <span>{{ ` ${option.name} ` }}</span>
                          <span class="recipient-remove" @click="remove(option)">❌</span>
                        </span>
                      </template>
                    </multiselect>
                    <div v-if="submitted && errors.has('farms')" class="invalid-feedback">
                      {{ errors.first('farms') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div id="map" class="card-body card-blue" />
            </div>
          </div>

          <div class="card-footer">
            <div class="form-group m-b-0 text-right">
              <div class="button-group">
                <button class="btn waves-effect waves-light btn-success" type="submit">
                  Save
                </button>
                <button class="btn waves-effect waves-light btn-secondary" type="button" @click="reset()">
                  Reset
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';
// import * as L from "../../../../assets/leaflet/leaflet-src";

export default {
  name: 'AddCluster',
  components: { Multiselect },
  data() {
    return {
      map: null,
      tileLayer: null,
      marker: null,
      layers: [],
      farms: [],
      coop: null,
      submitted: false,
      cluster: {
        name: '',
        coop: '',
        description: '',
        geo: { geometry: { coordinates: null } },
        farms: []
      },
      farmList: [],
      coops: []
    };
  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  mounted() {
    this.getCoop();
    this.initMap();
  },
  methods: {
    initMap() {
      this.map = L.map('map').setView([38.63, -90.23], 12);
      // Set up the OSM layer
      this.tileLayer = L.tileLayer(
        'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: 'Data © <a href="http://osm.org/copyright">OpenStreetMap</a>',
        maxZoom: 18
      });
      this.map.addLayer(this.tileLayer);
      this.map.locate({ setView: true });

      // Initialise the FeatureGroup to store editable layers
      var editableLayers = new L.FeatureGroup();
      this.map.addLayer(editableLayers);
      this.layers.push(editableLayers);
      var drawPluginOptions = {
        position: 'topright',
        draw: {
          polygon: {
            allowIntersection: false, // Restricts shapes to simple polygons
            // allowSelfIntersection: false,
            drawError: {
              color: '#e1e100', // Color the shape will turn when intersects
              message: '<strong>Oh snap!<strong> you can\'t draw that!' // Message that will show when intersect
            },
            shapeOptions: {
              color: '#97009c'
            }
          },
          // disable toolbar item by setting it to false
          polyline: false,
          circle: false, // Turns off this drawing tool
          rectangle: false,
          marker: false
        },
        edit: false
      };
      var drawEditOptions = {
        position: 'topright',
        draw: false,
        edit: {
          featureGroup: editableLayers, // REQUIRED!!
          remove: true
        }
      };

      // Initialise the draw control and pass it the FeatureGroup of editable layers
      var drawControl = new L.Control.Draw(drawPluginOptions);
      var drawEdit = new L.Control.Draw(drawEditOptions);
      this.map.addControl(drawControl);

      // var editableLayers = new L.FeatureGroup();
      // this.map.addLayer(editableLayers);

      this.map.on('draw:created', (e) => {
        var type = e.layerType;
        var layer = e.layer;

        if (type === 'marker') {
          layer.bindPopup('your cluster');
        }

        editableLayers.addLayer(layer);
        drawControl.remove(this.map);
        drawEdit.addTo(this.map);
        var geoJson = layer.toGeoJSON();
        this.cluster.geo = geoJson;
      });
      this.map.on('draw:deleted', () => {
        this.cluster.geo = '';
        drawEdit.remove(this.map);
        drawControl.addTo(this.map);
      });
    },

    handleSubmit() {
      this.submitted = true;
      this.$validator.validate()
        .then(valid => {
          if (valid) {
            this.save();
          }
        });
    },
    async save() {
      // this.cluster.farms = this.farms.map((farm) => {
      //     return farm.id
      // });
      // this.cluster.coop  = this.coop.id;
      // await this.$api.put(`/clusters`, this.cluster);
      // this.$toastr('success', 'New Cluster added successfully.', 'Cluster Saved');
      // this.$router.push({name: "clusters"});
    },
    async getFarms(e) {
      this.resetFarm();
      const response = await this.$api.get(`/audits/${e.id}/growers`);
      this.farmList = response.data;
    },
    async getCoop() {
      // let response = await this.$api.get(`/clusters/coops`);
      // this.coops   = response.data;
    },
    reset() {
      this.submitted = false;
      this.cluster = {
        name: '',
        description: '',
        geo: '',
        farms: []
      };
    },
    resetFarm() {
      this.farmList = [];
      this.farms = [];
    }
  }
}
</script>

<style scoped>
#map {
  width: 100%;
  height: 600px;
}

.recipient-tag {
  display: inline-block;
  padding: 3px 12px;
  background: #6ab43e;
  margin-right: 8px;
  margin-bottom: 8px;
  border-radius: 10px;
  cursor: pointer;
  color: #fff;
  text-transform: none;
  font-weight: bold;
}

.recipient-remove {
  padding: 0;
  font-size: 10px;
  margin-left: 5px;
}
</style>
